;(function() {
  'use strict'

  ElementClaim.$inject = ["$scope", "$log", "glDialog", "userService", "locationService", "postsService", "glUtils", "configService"];
  angular.module('app.element').controller('ElementClaim', ElementClaim)

  // --------------------

  /* @ngInject */
  function ElementClaim(
    $scope,
    $log,
    glDialog,
    userService,
    locationService,
    postsService,
    glUtils,
    configService
  ) {
    var log = $log.create('ElementClaim')
    var user = userService.get()

    $scope.data = {}
    $scope.form = {
      name: user.fullname,
    }

    $scope.post = {
      subject: {
        type: 'element',
        id: '0ee275a4-f443-475e-a24f-93ce5f5948ca',
      },
      content: null,
      nps: {
        entry: null,
      },
      mood: null,
      type: 'request',
      important: null,
      category: null,
      incidentDate: null,
      visibility: 'private',
      communityComments: false,
    }

    $scope.send = send

    function send() {
      if (!$scope.form.name || !$scope.form.phone) {
        $scope.data.error = 'Please enter a name and contact phone number.'
        return
      }
      if (!$scope.form.authority) {
        $scope.data.error =
          'You must confirm that you have the authority to claim ' +
          $scope.element.title +
          '.'
        return
      }

      $scope.data.error = null
      $scope.data.isSending = true

      // create users post
      var userPost = _.clone($scope.post)
      userPost.location = locationService.latest.position
      userPost.content =
        '* * * This conversation was automatically created to allow the Glow Team to speak with you ' +
        'about your recent business claim for ' +
        $scope.element.title +
        '. We will be in touch soon * * *'

      postsService.create(userPost).then(
        function(data) {
          // create claim post
          var claimPost = _.clone($scope.post)
          claimPost.location = locationService.latest.position
          claimPost.content = makeContent(data.id)

          postsService.create(claimPost, null, { insecure: true }).then(
            function() {
              $scope.element.isSubscriberOwned = true
              glDialog.show({
                templateUrl: 'dialog-orangealert.template.html',
                controller: function() {},
                escapeToClose: true,
                locals: {
                  title: 'Claim Sent',
                  message:
                    'We will be in touch shortly to get you up and running!',
                },
              })
              $scope.dialog.close()
            },
            function(err) {
              log.error('err', err)
              $scope.data.isSending = false
              $scope.data.error = 'Could not complete claim request.'
            }
          )
        },
        function(err) {
          log.error('err', err)
          $scope.data.isSending = false
          $scope.data.error = 'Could not complete claim request.'
        }
      )
    }

    function makeContent(userPostId) {
      var content = ''
      var data = {
        elementId: $scope.element.id,
        elementTitle: $scope.element.title,
        elementSubtext: $scope.element.extras.subtext,
        userId: user.id,
        userFullname: user.fullname,
        userUsername: user.username,
        userEmail: user.email,
        userGroupId: user.group && user.group.id,
        formName: $scope.form.name,
        formPhone: $scope.form.phone,
        elementLink: createAPLink($scope.element.id),
        userPost: createAPPostLink(userPostId),
        claimLink: createClaimLink(userPostId),
      }
      _.each(data, function(value, key) {
        content += key + ': ' + value + '\n'
      })
      return content
    }

    function createAPLink(elementId) {
      return configService.getUserPortalUrl() + '/element/' + elementId
    }

    function createAPPostLink(postId) {
      return configService.getUserPortalUrl() + '/post/' + postId
    }

    function createClaimLink(userPostId) {
      var params = {
        eid: $scope.element.id,
        etitle: $scope.element.title,
        esubtext: $scope.element.extras.subtext,
        uid: user.id,
        ufullname: user.fullname,
        uemail: user.email,
        upost: createAPPostLink(userPostId),
        sid: user.group && user.group.id,
        fname: $scope.form.name,
        fphone: $scope.form.phone,
      }
      return glUtils.addParams(
        configService.getAdminPortalUrl() + '/claim',
        params
      )
    }
  }
})()
